export default "__VITE_ASSET__9c13fb52__"